/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { useEffect } from 'react';
import { useMutation } from '@apollo/client';
import { useHistory } from 'react-router-dom';

import { CHECK_RESTRICTIONS } from '../../api/restrictions';
import useToken from '../../hooks/use-token';

const CheckRestrictions: React.FC = (): null => {
  const history = useHistory();
  const token = useToken();

  const [checkRestrictions, {
    called, loading, error, data,
  },
  ] = useMutation(CHECK_RESTRICTIONS, {
    context: { headers: { authorization: `Bearer ${token}` } },
  });

  useEffect(() => {
    checkRestrictions();
  }, [checkRestrictions]);

  useEffect(() => {
    if (error) {
      history.replace('/forbidden');
    } else if (data?.checkRestrictions) {
      const { redirectUrl } = data.checkRestrictions;
      if (redirectUrl) {
        window.location.href = redirectUrl;
      } else if (token) {
        history.replace(`/study-restrictions?token=${token}`);
      } else {
        history.replace('/forbidden');
      }
    }
  }, [called, loading, error, data, history, token]);

  return null;
};

export default CheckRestrictions;
